module.exports = __webpack_public_path__ + "143146fa24554ae2c5ac0a3982abb952.woff2";